import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '@rx-applications/clientsite/shared/config/utils';
import { Observable } from 'rxjs';

import { HttpService } from '@rx-applications/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class ClientConfigAPI {
  constructor(private http: HttpClient, private httpService: HttpService) {}

  getClientConfig(): Observable<User> {
    return this.http.get<User>(
      `${this.httpService.webApiUrl}Config/GetClientConfig`
    );
  }
}
